export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LotesPopUp.vue?vue&type=template&id=1b15d772&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/LotesPopUp.vue?vue&type=template&id=1b15d772&
// module id = null
// module chunks = 